// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3f2a047219f518f4","3433":"b5b175eb41821d31","3707":"b5b175eb41821d31"}[chunkId] + ".css";
};